<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Вернитесь к работе в Finch"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
      button-text="Подробнее"
      :max-width="450"
  >
    <template #default>
        <p class="upsell-after-cancel-modal__text mb-3">
            Ваши ученики, материалы и история занятий по-прежнему доступны в Finch.
        </p>
        <p class="upsell-after-cancel-modal__text mb-3">
            Если вы вернулись к работе или планируете новый набор учеников, подключите нужные функции
            и продолжайте работу в привычном формате.
        </p>
        <div class="upsell-after-cancel-modal__accent">
            <ul class="upsell-after-cancel-modal__list">
                <li>проводите уроки со звонками</li>
                <li>работайте на онлайн-доске</li>
                <li>добавляйте любое количество учеников</li>
            </ul>
        </div>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.upsell-after-cancel-modal__text {
    font-size: 14px;
}

.upsell-after-cancel-modal__accent {
    color: #ffffff;
    background-color: #556ee6;
    border-radius: 8px;
    padding: 12px 16px;
}

.upsell-after-cancel-modal__list {
    margin: 0;
    padding-left: 20px;
    font-size: 14px;
}
</style>
